import { BRIDGE_SEATS, bridgeSuitColor, type BridgeNtState, type BridgeSide, type BridgeSeat } from '../../games/bridge-nt';
import { rankLabel, suitLabel } from '../../games/heads-up-poker';
import './BridgeHistory.css';

export interface BridgeHistoryProps { state: BridgeNtState; yourSide: BridgeSide | null; liveOrder?: boolean }
const positions = ['top', 'right', 'bottom', 'left'] as const;
interface HistoryRow { leader: BridgeSeat; cards: BridgeNtState['current']['cards']; winner: BridgeSeat | null; number: number; ply: number; partial: boolean }

/** Public played cards only. Preserve lead order; viewpoint changes position
 * metadata, never card chronology. No hands, private proofs or replay controls.
 */
export function BridgeHistory({ state, yourSide, liveOrder = false }: BridgeHistoryProps) {
  const rows: HistoryRow[] = state.completed.map((trick, index) => ({
    ...trick, number: index + 1, ply: (index + 1) * 4, partial: false,
  }));
  if (state.current.cards.length > 0) rows.push({
    ...state.current, winner: null,
    number: state.completed.length + 1, ply: state.completed.length * 4 + state.current.cards.length, partial: true,
  });
  if (liveOrder && state.phase === 'play') rows.reverse();
  if (rows.length === 0) return null;
  return (
    <ol className="bridge-history-list" data-testid="bridge-history-list" aria-label="公開されたトリックの履歴">
      {rows.map(row => <li className="bridge-history-row" key={row.number} data-testid="bridge-history-row" data-ply={row.ply} data-partial={row.partial} data-winner={row.winner ?? ''} aria-label={`トリック ${row.number}${row.partial ? ' 途中' : `、${row.winner?.[0].toUpperCase()}の勝ち`}`}>
        <span className="bridge-history-number">{row.number}</span>
        <span className="bridge-history-cards">
          {row.cards.map((card, order) => {
            const index = (BRIDGE_SEATS.indexOf(row.leader) + order) % 4;
            const seat = BRIDGE_SEATS[index]; const winner = !row.partial && seat === row.winner;
            const position = positions[(index - (yourSide === 'Second' ? 1 : 0) + 4) % 4];
            return <span key={`${card.suit}:${card.rank}`} className="bridge-history-public-card" data-testid="bridge-history-card" data-seat={seat} data-order={order + 1} data-position={position} data-winner={winner} data-suit={card.suit} style={{ color: bridgeSuitColor(card.suit) }} aria-label={`${order + 1}枚目 ${seat[0].toUpperCase()} ${suitLabel(card.suit)}${rankLabel(card.rank)}${winner ? ' 勝ち札' : ''}`}>
              <span className="bridge-history-card-seat">{seat[0].toUpperCase()}</span>
              <span className="bridge-history-card-face"><span>{suitLabel(card.suit)}</span><strong>{rankLabel(card.rank)}</strong></span>
            </span>;
          })}
        </span>
      </li>)}
    </ol>
  );
}
